import React, { type PropsWithChildren } from 'react';
import { SkeletonItem } from '@atlaskit/side-navigation';
import type { ToggleableFeatureKey } from '../../common/types.tsx';
import { useEnablingFeature } from '../../controllers/board-features/index.tsx';

type Props = PropsWithChildren<{
	feature: ToggleableFeatureKey;
	hasFeature: boolean;
}>;

export const ToggleableFeatureSkeletonItem = ({ hasFeature, feature, children }: Props) => {
	const [isEnabling] = useEnablingFeature({ feature });

	if (isEnabling) {
		return <SkeletonItem />;
	}

	return hasFeature ? <>{children}</> : null;
};
